/****************************************************
 * Module Name:  AddTenderStoneRemarkModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import { Box, TextField, Container, Button, } from "@mui/material";
import Modal from "react-bootstrap/Modal";
import logo from '../../../images/pansuriya.jpg'
import "./../../../style/modalstyle.css";
import Constants from "../../../utility/constants";
const AddTenderStoneRemarkModal = ({ remarkData, handleSave, handleClose, show }) => {

    const [remark, setRemark] = useState(remarkData);

    return (
        <>
            <Box >
                < Modal backdrop="static" show={show} onHide={handleClose} enforceFocus={false} >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <img
                                src={logo}
                                height="40pt"
                                width="40pt"
                                alt={Constants.COMPANY_SITE}
                            />
                            &nbsp;&nbsp;ADD REMARK
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Container maxWidth="xxl">
                            <Box
                                sx={{
                                    width: "100%",
                                    position: "relative",
                                    "& .MuiTablePagination-selectLabel": {
                                        marginTop: "15px",
                                    },
                                    "& .MuiTablePagination-displayedRows": {
                                        marginTop: "15px",
                                    },
                                    "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                                        fontWeight: Constants.defaultFontWeight,
                                    },
                                    "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
                                        color: "#1976d2",
                                        padding: "4px 5px",
                                        borderRadius: "4px",
                                    },
                                    "& .css-cc8tf1": {
                                        fontWeight: Constants.defaultFontWeight,
                                    },
                                    "& .css-znmrd6-MuiButtonBase-root-MuiButton-root": {
                                        color: "#1976d2",
                                        padding: "5px 5px",
                                        borderRadius: "4px",
                                    },
                                    height: "20vh",
                                }}
                            >
                                <TextField
                                    margin="normal"
                                    fullWidth
                                    multiline
                                    rows={4}
                                    label={"Add Remark"}
                                    placeholder={"Add Remark"}
                                    value={remark}
                                    onChange={(e) =>
                                        setRemark(e.target.value)
                                    }
                                />
                            </Box>

                        </Container>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button sx={{ mr: 1 }} variant="contained" color="info" onClick={() => {
                            handleSave(remark);
                            handleClose();
                        }}>
                            Submit
                        </Button>
                        <Button variant="contained" color="error" onClick={handleClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal >
            </Box >
        </>
    );
};

export default AddTenderStoneRemarkModal;
